import React from "react";
import "./cta.css"

const Ctasection = () => {
  return (
    <section id="cta" class="emk-cta-section">
      <div class="emk-cta-container">
        <div class="emk-cta-panel">
          <div class="emk-cta-grid-bg"></div>
          <div class="emk-cta-corner top-left"></div>
          <div class="emk-cta-corner bottom-right"></div>

          <div class="emk-cta-layout">
            <div class="emk-cta-text">
              <div class="emk-cta-meta">
                <span class="emk-cta-badge">INDUSTRIAL CONNECT</span>
                <span class="emk-cta-status-pulse"></span>
                <span class="emk-cta-status-lbl">OPERATIONS LIVE</span>
              </div>
              <h2 class="emk-cta-title">
                Accelerate Your Production <br />
                With Arklon Solutions
              </h2>
              <p class="emk-cta-desc">
                Connect directly with our engineering team to request custom
                technical component pricing specifications, processing quotes,
                or materials consultations.
              </p>
            </div>

            <div class="emk-cta-actions">
              <div class="emk-cta-button-box">
                <a href="tel:+914912567385" class="emk-cta-primary-btn">
                  <span class="emk-cta-btn-glow"></span>
                  <div class="emk-cta-btn-content">
                    <div class="emk-cta-icon">
                      <svg
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>
                      </svg>
                    </div>
                    <div class="emk-cta-label-group">
                      <span class="emk-cta-btn-sub">DIRECT PHONELINE</span>
                      <span class="emk-cta-btn-main">+91 491 2567385</span>
                    </div>
                  </div>
                </a>

                <div class="emk-cta-support-lbl">
                  <span class="emk-cta-mono-text">LOC // PALAKKAD, KERALA</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Ctasection;
